import { observer, useLocalObservable } from 'mobx-react';
import { Tooltip } from 'react-tooltip';
import { useRef, useEffect } from 'react';
import { isPhoneOrTablet } from '../../utils/utils';
import pubSub from '../../utils/pubsub';

export const ICON_BUTTON_ICONS = {
  AGENTIC_AI: '/icons/clean/agentic-ai.svg',
  PERSON: '/icons/clean/person.svg',
  CHAT_SQUARE_TEXT: '/icons/clean/chat-square-text.svg',
  CHAT_RIGHT_DOTS: '/icons/clean/chat-right-dots.svg',
  CHAT_LEFT_QUOTE: '/icons/clean/chat-left-quote.svg',
  SHARE: '/icons/clean/share.svg',
  HOME: '/icons/clean/house.svg',
  TRASH: '/icons/clean/trash.svg',
  DOWNLOAD: '/icons/clean/download.svg',
  ARROW_COUNTERCLOCKWISE: '/icons/clean/arrow-counterclockwise.svg',
  ARROW_REPEAT: '/icons/clean/arrow-repeat.svg',
  STOP: '/icons/clean/stop.svg',
  ENVELOPE_CHECK: '/icons/clean/envelope-check.svg',
  CHAT_RIGHT_TEXT: '/icons/clean/chat-right-text.svg',
  X_LG: '/icons/clean/x-lg.svg',
  HAND_THUMBS_UP: '/icons/clean/hand-thumbs-up.svg',
  HAND_THUMBS_DOWN: '/icons/clean/hand-thumbs-down.svg',
  QUESTION_LG: '/icons/clean/question-lg.svg',
  QUESTION_CIRCLE: '/icons/clean/question-circle.svg',
  FLOPPY_2_FILL: '/icons/clean/floppy2-fill.svg',
  PAPERCLIP: '/icons/clean/paperclip.svg',
  COPY: '/icons/clean/copy.svg',
  ARCHIVE: '/icons/clean/archive.svg',
  CHEVRON_UP: '/icons/clean/chevron-up.svg',
  CHEVRON_DOWN: '/icons/clean/chevron-down.svg',
  CHEVRON_RIGHT: '/icons/clean/chevron-right.svg',
  PEN: '/icons/clean/pen.svg',
  CASH_STACK: '/icons/clean/cash-stack.svg',
  ARROW_RIGHT_SQUARE: '/icons/clean/arrow-right-square.svg',
  FILE_EARNMARK_PDF: '/icons/clean/file-earmark-pdf.svg',
  PORTFOLIO_COMPANY: '/icons/clean/portfolioCo.svg',
  INVEST_PROFILE: '/icons/clean/Corporate-building.svg',
  THREE_DOTS: '/icons/clean/three-dots.svg',
  THREE_DOTS_VERTICAL: '/icons/clean/three-dots-vertical.svg',
  INFO_CIRCLE: '/icons/clean/info-circle.svg',
  ENVELOPE_DASH: '/icons/clean/envelope-dash.svg',
  CHECK_CIRCLE: '/icons/clean/check-circle.svg',
  CHECK_LG: '/icons/clean/check-lg.svg',
  GEO_ALT: '/icons/clean/geo-alt.svg',
  TELEPHONE: '/icons/clean/telephone.svg',
  ENVELOPE: '/icons/clean/envelope.svg',
  PEOPLE: '/icons/clean/people.svg',
  STAR: '/icons/clean/star.svg',
  STAR_FILL: '/icons/clean/star-fill.svg',
  HOURGLASS: '/icons/clean/hourglass.svg',
  SQUARE_CHECK: '/icons/clean/square-check.svg',
  FILTER: '/icons/clean/filter.svg',
  FILTER_CIRCLE: '/icons/clean/filter-circle.svg',
  FILTER_CIRCLE_FILL: '/icons/clean/filter-circle-fill.svg',
  FILTER_RIGHT: '/icons/clean/filter-right.svg',
  SEND: '/icons/clean/send.svg',
  ARROW_DOWN: '/icons/clean/arrow-down.svg',
  ARROW_LEFT: '/icons/clean/arrow-left.svg',
  SEARCH: '/icons/clean/search.svg',
  WATCHLIST: '/icons/clean/watchlist.svg',
  ARROW_LEFT_RIGHT: '/icons/clean/arrow-left-right.svg',
  CLOUD_SLASH: '/icons/clean/cloud-slash.svg',
  CLOUD_CHECK: '/icons/clean/cloud-check.svg',
  ARROWS_FULLSCREEN: '/icons/clean/arrows-fullscreen.svg',
  FUNNEL: '/icons/clean/funnel.svg',
  FUNNEL_FILL: '/icons/clean/funnel-fill.svg',
  SORT: '/icons/clean/sort.svg',
  SORT_DEFAULT: '/icons/clean/sort-default.svg',
  SORT_ALPHA_DOWN: '/icons/clean/sort-alpha-down.svg',
  SORT_ALPHA_DOWN_ALT: '/icons/clean/sort-alpha-down-alt.svg',
  SORT_ALPHA_UP: '/icons/clean/sort-alpha-up.svg',
  SORT_ALPHA_UP_ALT: '/icons/clean/sort-alpha-up-alt.svg',
  SORT_NUMERIC_DOWN: '/icons/clean/sort-numeric-down.svg',
  SORT_NUMERIC_DOWN_ALT: '/icons/clean/sort-numeric-down-alt.svg',
  SORT_NUMERIC_UP: '/icons/clean/sort-numeric-up.svg',
  SORT_NUMERIC_UP_ALT: '/icons/clean/sort-numeric-up-alt.svg',
  FILE_EARMARK_ARROW_DOWN: '/icons/clean/file-earmark-arrow-down.svg',
  FILE_EARMARK_ARROW_DOWN_FILL: '/icons/clean/file-earmark-arrow-down-fill.svg',
  LINKEDIN: '/icons/clean/linkedin.svg',
  VIEW_DETAILS_CUSTOM1: '/icons/clean/view-details-custom1.svg',
  APP_INDICATOR: '/icons/clean/app-indicator.svg',
  EXCLAMATAION_TRIANGLE_FILL: '/icons/clean/exclamation-triangle-fill.svg',
  ARROW_ANGLE_EXPAND: '/icons/clean/arrows-angle-expand.svg',
  ARROWS_ANGLE_CONTRACT: '/icons/clean/arrows-angle-contract.svg',
  GLOBE2: '/icons/clean/globe2.svg',
  FILE_EARMARK_TEXT: '/icons/clean/file-earmark-text.svg',
  EXCLAMATAION_CIRCLE: '/icons/clean/exclamation-circle.svg',
  BUILDING: '/icons/clean/building.svg',
  PHONE: '/icons/clean/phone.svg',
  BOX_ARROW_UP_RIGHT: '/icons/clean/box-arrow-up-right.svg',
  CHECK_SQUARE_FILL: '/icons/clean/check-square-fill.svg',
  SQUARE: '/icons/clean/square.svg',
  CHECK_SQUARE: '/icons/clean/check-square.svg',
  CIRCLE: '/icons/clean/circle.svg',
  CHECK_CIRCLE_FILL: '/icons/clean/check-circle-fill.svg',
  TOGGLE_ON: '/icons/clean/toggle-on.svg',
  TOGGLE_OFF: '/icons/clean/toggle-off.svg',
  TOGGLE_ON2: '/icons/clean/toggle2-on.svg',
  TOGGLE_OFF2: '/icons/clean/toggle2-off.svg',
  COLUMNS: '/icons/clean/columns.svg',
  COLUMNS_GAP: '/icons/clean/columns-gap.svg',
  LOCK_FILL: '/icons/clean/lock-fill.svg',
  GRID_1X2: '/icons/clean/grid-1x2.svg',
  VIEW_LIST: '/icons/clean/view-list.svg',
  BAR_CHART_LINE: '/icons/clean/bar-chart-line.svg',
  TABLE: '/icons/clean/table.svg',
  ROCKET: '/icons/clean/rocket.svg',
  GRAPH_UP: '/icons/clean/graph-up.svg',
  BULLSEYE: '/icons/clean/bullseye.svg',
  TOOLS: '/icons/clean/tools.svg',
  BOOKMARK: '/icons/clean/bookmark.svg',
  PROJECT: '/icons/clean/project.svg',
  COGWHEEL: '/icons/clean/cogwheel.svg',
  NEW_CHAT: '/icons/clean/new-chat.svg',
  RECENT_CHAT: '/icons/clean/recent-chat.svg',
  CARD: '/icons/clean/card.svg',
  UPLOAD_DOCUMENT: '/icons/clean/upload-document.svg',
  MICROPHONE: '/icons/clean/microphone.svg',
  SEND_CHAT: '/icons/clean/send-chat.svg',
  // OCTICONS
  OCTI_LIST_UNORDERED: '/icons/clean/octicons-list-unordered.svg',
  OCTI_LIST_ORDERED: '/icons/clean/octicons-list-ordered.svg',
  // UNKNOWN
  HEATMAP_UNKNOWN1: '/icons/clean/heat-map-unknown.svg',
  HEATMAP_BUBBLE_UNKNOWN1: '/icons/clean/heat-map-bubble-unknown.svg',
  // INDIVIDUALS
  AGE: '/icons/clean/age.svg',
  MALE: '/icons/clean/male.svg',
  FEMALE: '/icons/clean/female.svg'
};

export const ICON_BUTTON_TYPES = {
  DEFAULT: 'default', // BLACK
  BLUE: 'blue',
  RED: 'red',
  YELLOW: 'yellow',
  GREEN: 'green'
};

const getIconButtonId = (() => {
  let id = 0;
  return () => {
    id++;
    return 'icon-button' + id;
  };
})();

const ACTIVATION_KEYS = new Set(['Enter', ' ']);
const SPACE = ' ';

// Buttons on which a Space press started. Like a native button, Space activates on release, and
// only when the press started on the same button and the focus stayed there.
const spacePressedButtons = new WeakSet();

/**
 * Opt-in keyboard and screen-reader semantics for the div-based button: role, tab stop, label,
 * disabled state, a pressed state for toggle buttons and activation the way a native button
 * activates: Enter on keydown, Space on keyup, a held key only once. Off by default
 * so tab order and tests elsewhere in the app stay unchanged. A disabled button leaves the tab
 * order, unless a tooltip explains why it is disabled: then it stays focusable (activation is
 * still blocked), the tooltip opens on focus and describes the button. A tooltip whose text only
 * repeats the name does not describe it, so screen readers do not read the name twice.
 */
const accessibleButtonProps = ({
  accessible,
  disabled,
  pressed,
  label,
  tooltipId,
  tooltipText,
  onActivate
}) => {
  if (!accessible) {
    return {};
  }
  return {
    role: 'button',
    tabIndex: disabled && !tooltipId ? -1 : 0,
    'aria-label': label || undefined,
    'aria-disabled': disabled ? 'true' : undefined,
    'aria-pressed': typeof pressed === 'boolean' ? String(pressed) : undefined,
    'aria-describedby': tooltipId && tooltipText !== label ? tooltipId : undefined,
    onKeyDown: (event) => {
      if (!ACTIVATION_KEYS.has(event.key)) {
        return;
      }
      event.preventDefault();
      // A held key repeats its keydown. Acting on each repeat would remove chip after chip, as
      // the focus moves on to the next chip's button.
      if (event.repeat) {
        return;
      }
      if (event.key === SPACE) {
        spacePressedButtons.add(event.currentTarget);
        return;
      }
      onActivate(event);
    },
    onKeyUp: (event) => {
      if (event.key !== SPACE || !spacePressedButtons.delete(event.currentTarget)) {
        return;
      }
      event.preventDefault();
      onActivate(event);
    },
    onBlur: (event) => {
      spacePressedButtons.delete(event.currentTarget);
    }
  };
};

const IconButton = observer(
  ({
    id = null,
    icon = '',
    type = '',
    hoverType = '',
    withFill = true,
    filled = false,
    withBorder = true,
    disabled = false,
    onClick = () => {},
    innerText = '',
    outerText = '',
    tooltipArrowColor = '',
    tooltipVariant = 'dark',
    tooltipText = '',
    tooltipContent = null,
    tooltipClassName = '',
    tooltipClickable = false,
    forceOpenTooltip = false,
    tooltipPosition = 'bottom-center',
    tooltipOffset = null,
    showTooltipArrow = true,
    wrapClassName = '',
    iconOnRight = false,
    isPDF = false,
    onPDF = () => {},
    notificationDot = false,
    errorNotificationDot = false,
    newFeatureBadge = false,
    onButtonRef = () => {},
    onMouseEnter = () => {},
    onMouseLeave = () => {},
    linkContextMenu = [],
    highlightButtonBackground = false,
    accessible = false,
    ariaLabel = '',
    ariaPressed = undefined
  }) => {
    const btnRef = useRef(null);
    const pdfRef = useRef(null);
    const state = useLocalObservable(() => ({
      buttonId: getIconButtonId(),
      linkContextMenuOpened: false,
      toggleLinkContextMenu: () => {
        state.linkContextMenuOpened = !state.linkContextMenuOpened;
      }
    }));

    useEffect(() => {
      if (btnRef.current) {
        onButtonRef(btnRef.current);
      }
    }, []);

    useEffect(() => {
      const onAnyClick = () => {
        if (state.linkContextMenuOpened) {
          state.toggleLinkContextMenu();
        }
      };

      const onPubSubContextClick = (payload) => {
        if (payload?.event === 'icon-button-context-menu-trigger' && state.linkContextMenuOpened) {
          state.toggleLinkContextMenu();
        }
      };

      pubSub.subscribe(onPubSubContextClick);
      document.addEventListener('click', onAnyClick);

      return () => {
        pubSub.unsubscribe(onPubSubContextClick);
        document.removeEventListener('click', onAnyClick);
      };
    }, [state]);

    const click = (event) => {
      if (isPDF) {
        if (!disabled) {
          pdfRef?.current?.click?.();
        }
        return;
      }
      if (!disabled && typeof onClick === 'function') {
        onClick(event);
      }
    };

    let buttonType = ICON_BUTTON_TYPES.DEFAULT;
    if (Object.values(ICON_BUTTON_TYPES).includes(type)) {
      buttonType = type;
    }
    let buttonHoverType = '';
    if (Object.values(ICON_BUTTON_TYPES).includes(hoverType)) {
      buttonHoverType = hoverType;
    }

    const classNames = ['noselect', 'new-icon-button-wrap', buttonType];
    if (wrapClassName) {
      classNames.push(wrapClassName);
    }
    if (buttonHoverType) {
      classNames.push('hover-type-' + buttonHoverType);
    }
    if (disabled) {
      classNames.push('disabled');
    }
    if (withBorder) {
      classNames.push('bordered');
    }
    if (withFill) {
      classNames.push('with-fill');
      if (filled) {
        classNames.push('filled');
      }
    }
    if (iconOnRight) {
      classNames.push('icon-right');
    }
    if (highlightButtonBackground) {
      classNames.push('highlight-button-background');
    }
    if (!isPhoneOrTablet) {
      classNames.push('no-touch-hover');
    }

    const hasTooltip = !!tooltipText || !!tooltipContent;
    const tooltipId = accessible && hasTooltip ? `${id || state.buttonId}-tooltip` : null;

    return (
      <>
        <div
          onClick={click}
          className={classNames.join(' ')}
          id={id || state.buttonId}
          ref={btnRef}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          {...accessibleButtonProps({
            accessible,
            disabled,
            pressed: ariaPressed,
            label: ariaLabel || innerText,
            tooltipId,
            tooltipText,
            onActivate: click
          })}
          {...(linkContextMenu.length
            ? {
                onContextMenu: (event) => {
                  if (disabled) {
                    return;
                  }

                  event.preventDefault();
                  pubSub.publish({ event: 'icon-button-context-menu-trigger' });
                  state.toggleLinkContextMenu();
                }
              }
            : {})}
        >
          <div className="new-icon-button">
            {icon && (
              <div className="img-wrap">
                <img src={icon} />
              </div>
            )}
            {innerText && <div className="inner-text">{innerText}</div>}
            {notificationDot && !errorNotificationDot && <div className="notif-dot" />}
            {errorNotificationDot && !notificationDot && <div className="notif-dot error-dot" />}
            {notificationDot && errorNotificationDot && <div className="semi-notif-error-dot" />}
            {newFeatureBadge && (
              <div className="new-feature-badge">
                {typeof newFeatureBadge === 'string' ? newFeatureBadge : 'New'}
              </div>
            )}
          </div>
          {outerText && <div className="outer-text">{outerText}</div>}
          {isPDF && (
            <input
              style={{ display: 'none' }}
              type="file"
              name="upload"
              accept=".pdf"
              ref={pdfRef}
              onChange={(event) => {
                if (typeof onPDF === 'function' && event?.target?.files?.[0]) {
                  onPDF(event.target.files[0]);
                }
              }}
            />
          )}
        </div>
        {/* {tooltip-type-${buttonType}} */}
        {hasTooltip && !state.linkContextMenuOpened && (
          <Tooltip
            {...(tooltipId ? { id: tooltipId } : {})}
            anchorSelect={`#${id || state.buttonId}`}
            multiline={true}
            variant={tooltipVariant}
            arrowColor={tooltipArrowColor}
            opacity={1}
            noArrow={!showTooltipArrow}
            place={tooltipPosition}
            className={`icon-button-tooltip ${tooltipClassName || ''}`}
            clickable={tooltipClickable}
            {...(forceOpenTooltip ? { isOpen: true } : {})}
            {...(tooltipText ? { content: tooltipText } : {})}
            {...(tooltipContent ? { children: tooltipContent } : {})}
            {...(typeof tooltipOffset === 'number' ? { offset: tooltipOffset } : {})}
          />
        )}
        {!!linkContextMenu.length && state.linkContextMenuOpened && (
          <Tooltip
            anchorSelect={`#${id || state.buttonId}`}
            multiline={true}
            variant="dark"
            opacity={1}
            place="bottom-center"
            clickable={true}
            isOpen={true}
            className="icon-button-tooltip-context-link-menu"
          >
            {linkContextMenu.map((el, idx) => {
              return (
                <div className="context-link-menu-item" key={idx} onClick={el.onClick}>
                  <div className="left-side">
                    {!!el.icon && (
                      <div className="context-link-icon-wrap">
                        <img src={el.icon} />
                      </div>
                    )}
                    <div className={`context-link-text ${!el.icon ? 'no-icon' : ''}`}>
                      {el.text}
                    </div>
                  </div>
                  <div className="right-side">
                    {!!el.submenu?.length && (
                      <>
                        <div
                          className="context-submenu-link-icon-wrap"
                          id={`submenu-context-link-${idx}`}
                          onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                          }}
                        >
                          <img src={ICON_BUTTON_ICONS.CHEVRON_RIGHT} />
                        </div>
                        <Tooltip
                          anchorSelect={`#submenu-context-link-${idx}`}
                          multiline={true}
                          variant="dark"
                          opacity={1}
                          place="right-start"
                          clickable={true}
                          className="submenu-context-menu"
                          noArrow
                          offset={8}
                        >
                          {el.submenu.map((subEl, idx) => {
                            return (
                              <div
                                className="submenu-context-menu-item"
                                key={idx}
                                onClick={(event) => {
                                  event.preventDefault();
                                  event.stopPropagation();
                                  state.toggleLinkContextMenu();
                                  subEl.onClick(event);
                                }}
                              >
                                {subEl.text}
                              </div>
                            );
                          })}
                        </Tooltip>
                      </>
                    )}
                  </div>
                </div>
              );
            })}
          </Tooltip>
        )}
      </>
    );
  }
);

export default IconButton;
